import { Component, ViewChild } from '@angular/core';
import { Nav, Platform,Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Http, Headers } from '@angular/http';
import { LoadingController, AlertController} from 'ionic-angular';
//import {ViewController,NavController} from "@angular/core";
import { DataTablesModule } from 'angular-datatables';
import {ElementRef, Input } from '@angular/core';

import { OneSignal } from '@ionic-native/onesignal';
//import { UnderConstructionPage } from '../pages/under-construction/under-construction';
import { BaseurlProvider } from '../providers/baseurl/baseurl';

declare var window: any;
@Component({
  templateUrl: 'app.html',

})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  @Input() multiple: boolean = false;
  @ViewChild('photoInput') inputEl: ElementRef;
  shownGroup1 : null;
  rootPage: any = "RegGetOtpPage";
 
  
  company_name:any;
  login_type:any;
  login_type_id:any;
  login_name:any;
  pages: Array<{title: string, ic: any, component: any}>;

  
  p1: Array<{title: string, ic: any, component: any}>;
  p4: Array<{title: string, ic: any, component: any}>;
  p10: Array<{title: string, ic: any, component: any}>;
  
  userid:any;
  profile_pic:any;
  constructor(public events: Events,public http:Http,public loadingCtrl: LoadingController,public bUrl:BaseurlProvider,public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public oneSignal: OneSignal,public alertCtrl: AlertController) {
    
    this.initializeApp();
    events.subscribe('user:login', (loc) => {
      //console.log(loc);
      //console.log(window.location);
      window.location.assign('#/'+loc);
      window.location.reload();
    });
    
      var self=this;
    if (this.bUrl.decrypt(localStorage.getItem('userid')))
    {
      //code to check login exist or not
        let body = new FormData();
        body.append('id', this.bUrl.decrypt(localStorage.getItem('userid'))); 
        
        self.rootPage='HomePage';
        let headers: Headers = new Headers();
        headers.append("Authorization", "Basic " + btoa(this.bUrl.username + ":" + this.bUrl.password));
        this.http.post(this.bUrl.baseUrl + "client_user/check_user/",body,{headers: headers}) 
      
        .map(response => response.json())
        .subscribe(
        function(response) { //console.log(response);
          if(response.status==2)
          {
            //self.rootPage='HomePage';
          }
          else if(response.status==1)
          {
            let alert1 = self.alertCtrl.create({
              title: 'Login',
              message: 'Your Login is not approved by the admin .Please contact admin..!',
              buttons: [
                {
                  text: 'Ok',
                  role: 'cancel',
                  handler: () => {
                   
                    window["deleteTag"]('-1');
                    localStorage.removeItem('email');
                    localStorage.removeItem('login_type');
                    localStorage.removeItem('company_name');
                    localStorage.removeItem('userid');
                    localStorage.removeItem('login_name');
                    localStorage.removeItem('profile');
                    localStorage.removeItem('company_id');
                    localStorage.removeItem('company_type');
                    localStorage.removeItem('mobile');
                    localStorage.removeItem('service_port');
                    localStorage.removeItem('login_type_id');
                    localStorage.removeItem('is_place_order');
                    localStorage.removeItem('client_notification');
                    localStorage.clear();
                    self.rootPage='RegGetOtpPage';
                  }
                }
              ]
            });
            alert1.present();
          }
          else if(response.status==0)
          {
            let alert1 = self.alertCtrl.create({
              title: 'Login',
              message: 'Your Login account is deleted .Please contact admin..!',
              buttons: [
                {
                  text: 'Ok',
                  role: 'cancel',
                  handler: () => {
                    localStorage.removeItem('email');
                    localStorage.removeItem('login_type');
                    localStorage.removeItem('company_name');
                    localStorage.removeItem('userid');
                    localStorage.removeItem('login_name');
                    localStorage.removeItem('profile');
                    localStorage.removeItem('company_id');
                    localStorage.removeItem('company_type');
                    localStorage.removeItem('mobile');
                    localStorage.removeItem('service_port');
                    localStorage.removeItem('login_type_id');
                    localStorage.removeItem('is_place_order');
                    localStorage.removeItem('client_notification');
                    self.rootPage='RegGetOtpPage';
                  }
                }
              ]
            });
            alert1.present();
          }

        },
        function(error) { //console.log(error);
      
        },
        function() { 
        });
      //code to check login exist or not

     
    }
    else
    {
      console.log('ddd');
      self.rootPage='RegGetOtpPage';
      console.log( self.rootPage);
      
    }
    // used for an example of ngFor and navigation
    if(this.bUrl.decrypt(localStorage.getItem('profile'))!='' && this.bUrl.decrypt(localStorage.getItem('profile'))!= null && this.bUrl.decrypt(localStorage.getItem('profile'))!= undefined) 
    {
       this.profile_pic=this.bUrl.baseUrl+''+this.bUrl.decrypt(localStorage.getItem('profile'));
    }
    else
    {
       this.profile_pic='';
    }
    this.login_type_id=this.bUrl.decrypt(localStorage.getItem('login_type_id'));
    //console.log(this.login_type_id);
   // //console.log("this.login_type_id");
   // //console.log(this.login_type_id);
    this.login_type=this.bUrl.decrypt(localStorage.getItem('login_type'));
    this.company_name=this.bUrl.decrypt(localStorage.getItem('company_name'));
    this.login_name=this.bUrl.decrypt(localStorage.getItem('login_name'));
    this.userid=this.bUrl.decrypt(localStorage.getItem('userid'));
    if (this.bUrl.decrypt(localStorage.getItem('userid')))
    {
    
      this.p1 = [
        { title: 'Home', ic:'ios-home', component: "HomePage" },
       ];
     
      this.p4 = [
        { title: ' All Containers', ic:'expand', component: "ReportsAllVoyagePage" },
        { title: 'Vessel Wise', ic:'ios-boat', component: "ReportsVesselWisePage" },
        { title: 'Port Wise', ic:'pin', component: "ReportsPortWisePage" },
        // { title: 'Transporter Wise', ic:'man', component: "ReportsTransporterWisePage" },
      
        ];
      this.p10 = [
      { title: 'Track Container', ic:'logo-buffer',component: "TrackContainerPage"},  
      { title: 'Notification', ic:'ios-notifications',component: "PushNotificationPage"},
      { title: 'News Feed', ic:'logo-reddit',component: "NewsFeedPage"},
      { title: 'Vessel Schedule', ic:'ios-apps',component: "VesselSchedulePage"},
      { title: 'Distance Calculator', ic:'md-car',component: "DistanceCalculatorPage"},
      { title: 'Calculator', ic:'ios-calculator',component: "CalculatorPage"},
      { title: 'Inquiry', ic:'ios-clipboard',component: "ClientInquirePage"},
      { title: 'Track Vessel', ic:'ios-aperture',component: "UnderConstructionPage"},
      { title: 'Add User', ic:'ios-contact',component: "EditUserPage"},
      { title: 'Settings', ic:'ios-hammer',component: "UnderConstructionPage"},
      { title: 'Logout', ic:'ios-navigate',component: "LogoutPage"},
      ];        
        
    }
		
  }

  initializeApp() {
    this.platform.ready().then(() => {
      
      //self.rootPage = self.userid ? HomePage : LoginPage;
            /***********************SMS TRIAL********************** */
            /*  var permissions = window.plugins.permissions;
                permissions.hasPermission(checkPermissionCallback, null, permissions.R);

                function checkPermissionCallback(status) {
                  //alert(JSON.stringify(status));
                  if(!status.hasPermission) {
                    var errorCallback = function() {
                        //ionic.Platform.exitApp();
                        //alert("error");
                    }

                    permissions.requestPermission(function(status) {

                      if( !status.hasPermission ) errorCallback();
                    }, errorCallback, permissions.READ_SMS);
                  }
                }

				*/
              /***************************************************** */



      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.oneSignal.startInit('e5123fb3-50a4-4fff-a576-9c8f15427f92', '952927230381');
      
      this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);
      this.oneSignal.handleNotificationReceived().subscribe((msg) => {
        //alert(JSON.stringify(msg));
      });
      this.oneSignal.handleNotificationOpened().subscribe((msg) => {
        //alert(JSON.stringify(msg));
      });
      this.oneSignal.endInit();



    });
  }

  openPage(page) {
    
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    let pageLoading = this.loadingCtrl.create({
      duration:8000,
      dismissOnPageChange:true,
      //enableBackdropDismiss:true,
      spinner:'dots'
    });

    pageLoading.present();
    this.nav.setRoot(page.component);
    
  } 
  toggleGroup1(group)
  {
      if (this.isGroupShown1(group)) {
          this.shownGroup1 = null;
      } else {
          this.shownGroup1 = group;
      }
  }
  isGroupShown1(group) {
    return this.shownGroup1 === group;
  };

    change_profile()
  {
    var self=this;
    //console.log('file_selected');
    let body = new FormData();
    let inputEl: HTMLInputElement = this.inputEl.nativeElement;
    body.append('photo', inputEl.files.item(0));
    body.append('id', this.bUrl.decrypt(localStorage.getItem('userid'))); 
    

   
     let loading = this.loadingCtrl.create({
        content: 'Please wait...'
      });

    loading.present();
    let headers: Headers = new Headers();
    headers.append("Authorization", "Basic " + btoa(this.bUrl.username + ":" + this.bUrl.password));
    this.http.post(this.bUrl.baseUrl + "client_user/change_profile/",body,{headers: headers}) 
   
    .map(response => response.json())
    .subscribe(
    function(response) { //console.log(response);
    //loading.dismiss();profile_pic
    if(response.status=='1')
    {
      self.profile_pic=self.bUrl.baseUrl+''+response.profile;
      localStorage.setItem('profile',self.bUrl.encrypt(response.profile));      
    }
    else
    {
      //console.log('fail');
    }
    },
    function(error) { //console.log(error);
   //loading.dismiss();
    },
    function() { 
     
    loading.dismiss();
      
    }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts